import { render } from "./listarRecepciones.vue?vue&type=template&id=710e0b36&scoped=true"
import script from "./listarRecepciones.vue?vue&type=script&lang=js"
export * from "./listarRecepciones.vue?vue&type=script&lang=js"

import "./listarRecepciones.vue?vue&type=style&index=0&id=710e0b36&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710e0b36"]])

export default __exports__